export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

// RESET PASSWORD
export const validatorResetpasswordRules = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[!@#\$%\^\&*\)\(+=._-])([a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+)$/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  const checkLength = Number(password.length) >= 8 && Number(password.length) <= 16
  return validPassword && checkLength
}

export const validatorGoogleMapsUrl = value => {
  if (!value || value.length === 0) {
    return false
  }
  // Google Maps URL patterns:
  // - https://maps.google.com/
  // - https://www.google.com/maps/
  // - https://goo.gl/maps/
  // - https://maps.app.goo.gl/
  /* eslint-disable no-useless-escape */
  const googleMapsPatterns = [
    /^https?:\/\/(www\.)?google\.[a-z]+\/maps/i,
    /^https?:\/\/maps\.google\.[a-z]+/i,
    /^https?:\/\/goo\.gl\/maps/i,
    /^https?:\/\/maps\.app\.goo\.gl/i,
  ]
  /* eslint-enable no-useless-escape */
  return googleMapsPatterns.some(pattern => pattern.test(value))
}
